import { BreadcrumbItem } from "../../types";

type GenerateItemSchema = (item: BreadcrumbItem, position: number) => object;
const getItemSchema: GenerateItemSchema = ({ url, text }, position) => ({
  "@type": "ListItem",
  position,
  name: text,
  item: url
});

type GenerateSchema = (items: BreadcrumbItem[]) => object;
const generateSchema: GenerateSchema = items => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, index) => getItemSchema(item, index + 1))
});

export { generateSchema };
